// extracted by mini-css-extract-plugin
export default {"layout":"layout--g078P"};